module.exports = ["ขณะนี้","%s วินาทีที่แล้ว","%s นาทีที่แล้ว","%s ชั่วโมงที่แล้ว","%s วันที่แล้ว","%s อาทิตย์ที่แล้ว","%s เดือนที่แล้ว","%s ปีที่แล้ว"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/th-TH.json
// module id = 0DJb
// module chunks = 1